

import React, { Component } from "react";
import { Modal, Form, Row, Col, Table, Button } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import SingleSelectionDropdown from '../../reusableDropDownComponents/SingleSelectionDropdown';

const EDIT_STUDENT_BULK = gql`
  mutation($params:EditBlukStudentInput) {
    editBulkStudent(params: $params)
  }
`;

class UpdateStudentsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultvalue: 0,
            dataClear: 1,
            branch_id: "",
            class_id: "",
            exam_id: "",
            sectionSelectedValue: [],
            getSections: [],
            getExams: [],
            getClasses: [],
            studentData: props.studentData || [],
            data: [],
            selectedData: [],
            selectAll: true,
            searchQuery: "",
            currentPage: 1,
            rowsPerPage: 10,
            updateSection: "",
            updateSectionError: "",
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            successMessage: "",
        };
    }


    componentDidUpdate(prevProps, prevState) {
        const { branch_id, class_id, exam_id } = this.state;

        if (
            branch_id &&
            class_id &&
            exam_id &&
            (branch_id !== prevState.branch_id ||
                class_id !== prevState.class_id ||
                exam_id !== prevState.exam_id)
        ) {
            const sections = this.getSections(branch_id, exam_id, class_id);
            this.setState({
                getSections: sections,
                sectionSelectedValue: sections,
            }, this.handleFilter);
        }



        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch_id: "",
                class_id: "",
                exam_id: "",
                sectionSelectedValue: [],
                getSections: [],
                getExams: [],
                getClasses: [],
                studentData: this.props.studentData || [],
                data: [],
                selectedData: [],
                selectAll: true,
                searchQuery: "",
                currentPage: 1,
                rowsPerPage: 10,
                updateSection: "",
                updateSectionError: "",
                loadingSpinner: 0,
                currentStep: 1,
                submitError: "",
                dataClear: 1,
                defaultvalue: 0,
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    // ✅ Get unique exams for a branch
    getExams = (branch_id) => {
        const { globals } = this.props;
        const uniqueExamIds = [
            ...new Set(
                globals.b_e_c_s_data
                    .filter((item) => item.branch_id == branch_id)
                    .map((i) => i.exam_id)
            ),
        ];

        return uniqueExamIds
            .map((id) => {
                const exam = globals.exams.find((e) => e.id == id);
                return exam ? { value: exam.id, label: exam.exam } : null;
            })
            .filter(Boolean);
    };

    // ✅ Get classes for a selected branch + exam
    getClasses = (branch_id, exam_id) => {
        const { globals } = this.props;
        const uniqueClassIds = [
            ...new Set(
                globals.b_e_c_s_data
                    .filter((item) => item.branch_id == branch_id && item.exam_id == exam_id)
                    .map((i) => i.class_id)
            ),
        ];

        return uniqueClassIds
            .map((id) => {
                const cls = globals.classes.find((c) => c.id == id);
                return cls ? { value: cls.id, label: cls.class } : null;
            })
            .filter(Boolean);
    };

    // ✅ Get sections for selected branch + exam + class
    getSections = (branch_id, exam_id, class_id) => {
        const { globals } = this.props;
        const uniqueSectionIds = [
            ...new Set(
                globals.b_e_c_s_data
                    .filter(
                        (item) =>
                            item.branch_id == branch_id &&
                            item.exam_id == exam_id &&
                            item.class_id == class_id
                    )
                    .map((i) => i.section_id)
            ),
        ];

        return uniqueSectionIds
            .map((id) => {
                const sec = globals.globalSections.find((s) => s.id == id);
                return sec ? { value: sec.id, label: sec.section_name } : null;
            })
            .filter(Boolean);
    };

    // ✅ Handle dropdown change
    handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "updateSection") {
            this.setState({
                updateSection: value,
                updateSectionError: "",
            })
        }

        if (name === "branch") {
            this.setState({
                branch_id: value,
                exam_id: "",
                class_id: "",
                getExams: this.getExams(value),
                getClasses: [],
                sectionSelectedValue: [],
                getSections: [],
            }, this.handleFilter);
        }

        if (name === "exam") {
            this.setState({
                exam_id: value,
                class_id: "",
                getClasses: this.getClasses(this.state.branch_id, value),
                getSections: [],
                sectionSelectedValue: [],
            }, this.handleFilter);
        }

        if (name === "class") {
            this.setState({
                class_id: value,
                sectionSelectedValue: [],
                getSections: this.getSections(
                    this.state.branch_id,
                    this.state.exam_id,
                    value
                ),
            }, this.handleFilter);
        }
    };

    // ✅ Handle section multi-select
    handleMultipleSelectInputChange = (selectedList) => {
        this.setState({
            sectionSelectedValue: selectedList,
        }, this.handleFilter);
    };

    // ✅ Filter data for table
    handleFilter = () => {
        const { branch_id, class_id, exam_id, sectionSelectedValue } = this.state;
        const { studentData } = this.props;

        let filteredData = studentData || [];
        const selectedSectionIds = sectionSelectedValue.map((s) => Number(s.value));


        if (branch_id) {
            filteredData = filteredData.filter((s) => +s.branch === +branch_id);
        }
        if (exam_id) {
            filteredData = filteredData.filter((s) => +s.exam_id === +exam_id);
        }
        if (class_id) {
            filteredData = filteredData.filter((s) => +s.class === +class_id);
        }
        if (selectedSectionIds.length > 0) {
            filteredData = filteredData.filter((item) =>
                selectedSectionIds.includes(Number(item.section))
            );
        }

        this.setState({
            data: filteredData.map((d) => ({ ...d, selected: true })),
            selectedData: filteredData,
            selectAll: true,
        });
    };

    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const updatedData = prevState.data.map((item) =>
                String(item.id) === String(id) ? { ...item, selected: !item.selected } : item
            );

            const selectedData = updatedData.filter((item) => item.selected);

            return {
                data: updatedData,
                selectAll: selectedData.length === prevState.data.length,
                selectedData,
            };
        });
    };

    handleSelectAllChange = () => {
        this.setState((prevState) => {
            const selectAll = !prevState.selectAll;
            const updatedData = prevState.data.map((item) => ({
                ...item,
                selected: selectAll,
            }));

            return {
                selectAll,
                data: updatedData,
                selectedData: selectAll ? updatedData : [],
            };
        });
    };

    handleSearch = (event) => {
        this.setState({ searchQuery: event.target.value, currentPage: 1 });
    };

    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const fields = [
            { key: "updateSection", errorKey: "updateSectionError", errorMessage: "Select section" },
        ];

        for (const field of fields) {
            if (this.state[field.key] === "") {
                this.setState({ [field.errorKey]: field.errorMessage });
                return "";
            }
        }

        let params = {
            section_id: parseInt(this.state.updateSection),
            userList: this.state.selectedData.map((item) => ({ mobile: item.contact_no }))
        };


        const array = this.state.sectionSelectedValue.map(item => Number(item.value));
        const single = Number(this.state.updateSection);
        const shouldCallApi = !(array.length === 1 && array[0] === single);

        if (!shouldCallApi) {
            this.setState({
                loadingSpinner: 1,
                currentStep: 5,
                successMessage: "No Changes"
            });

            setTimeout(() => {
                this.props.onHide();
            }, 1500);
        } else {
            this.editBulkStudent(params).catch(error => {
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message)
                });
                console.error(
                    "ERR =>",
                    error.graphQLErrors.map(x => x.message)
                );
                setTimeout(() => {
                    this.props.onHide();
                }, 5000);
            });
        }
    };



    editBulkStudent = async (params) => {
        console.log("child");
        await this.props.editBulkStudent({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.editBulkStudent) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                        successMessage: "Student Data Updated successfully "
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1000);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false);
    };

    render() {
        const {
            branch_id,
            exam_id,
            class_id,
            getExams,
            getClasses,
            getSections,
            sectionSelectedValue,
            data,
            selectAll,
            currentPage,
            rowsPerPage,
            searchQuery,
            updateSection,
            updateSectionError,
            loadingSpinner,
            currentStep,
            submitError,
            successMessage,
        } = this.state;

        const { globals } = this.props;


        // Filter search
        const filteredSearchData = data.filter((item) =>
            item.student_name?.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Pagination
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentData = filteredSearchData.slice(indexOfFirstRow, indexOfLastRow);
        const totalPages = Math.ceil(filteredSearchData.length / rowsPerPage);

        const updateSectionFields = [
            { rowId: 1, label: "Select Branch", options: globals.globalBranches.map((item) => ({ value: item.id, label: item.branch_name })), name: "branch", value: branch_id },
            { rowId: 2, label: "Select Exam", options: getExams, name: "exam", value: exam_id },
            { rowId: 3, label: "Select Class", options: getClasses, name: "class", value: class_id },
            { rowId: 4, label: "Select Section", options: getSections, name: "section" },
        ];

        const sectionUpdateFormFields = [
            { label: "Select Section", options: getSections, name: "updateSection", value: updateSection, error: updateSectionError, },
        ];

        return (
            <Modal {...this.props} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Update User</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Row>

                              <SingleSelectionDropdown onSelect={this.handleSelection} 
                            showBranch={true}
                            />


                            {/* {updateSectionFields.map((field) => (
                                <Form.Group as={Col} lg={3} key={field.rowId}>
                                    <h6>{field.label}</h6>
                                    {field.rowId === 4 ? (
                                        <MultiSelect
                                            options={getSections}
                                            value={sectionSelectedValue}
                                            onChange={this.handleMultipleSelectInputChange}
                                            labelledBy="Select Section"
                                            hasSelectAll={true}
                                        />
                                    ) : (
                                        <Form.Control
                                            as="select"
                                            name={field.name}
                                            value={field.value}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value="">--Select--</option>
                                            {field.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    )}
                                </Form.Group>
                            ))} */}
                        </Form.Row>
                    </Form>

                    {branch_id && exam_id && class_id && sectionSelectedValue.length > 0 && (
                        <>
                            <Row className="mt-3">
                                <Col lg={4}>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={this.handleSearch}
                                        className="form-control"
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={12}>
                                    <Table striped bordered hover className="text-center mt-3">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={this.handleSelectAllChange}
                                                    /> Select All
                                                </th>
                                                <th>Sno</th>
                                                <th>Name</th>
                                                <th>Branch</th>
                                                <th>Class</th>
                                                <th>Exam</th>
                                                <th>Section</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentData.length > 0 ? (
                                                currentData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={item.selected || false}
                                                                onChange={() =>
                                                                    this.handleCheckboxChange(item.id)
                                                                }
                                                            />
                                                        </td>
                                                        <td>{(currentPage - 1) * rowsPerPage + (index + 1)}</td>
                                                        <td>{item.student_name}</td>
                                                        <td>{item.branch_name}</td>
                                                        <td>{item.class_name}</td>
                                                        <td>{item.exam_name}</td>
                                                        <td>{item.section_name}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ color: "green", textAlign: "center" }}>
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                    <div className="d-flex justify-content-end align-items-center">
                                        <button
                                            onClick={() => this.handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="btn btn-outline-primary btn-sm mx-2"
                                        >
                                            Previous
                                        </button>
                                        <span>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                        <button
                                            onClick={() => this.handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="btn btn-outline-success btn-sm mx-2"
                                        >
                                            Next
                                        </button>
                                    </div>
                                </Col>
                            </Row>

                            <Form>
                                <Form.Row>
                                    {sectionUpdateFormFields.map((field, index) => (
                                        <Col key={index} lg={4} md={12} sm={12}>
                                            <Form.Group controlId={field.name}>
                                                <Form.Label className="text-uppercase">{field.label}</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={this.handleInputChange}
                                                    defaultValue={this.state.defaultvalue}
                                                >
                                                    <option value={this.state.defaultvalue}>-- {field.label} --</option>
                                                    {field.options.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Control>

                                                {field.error && (
                                                    <Form.Text className="text-danger">{field.error}</Form.Text>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    ))}
                                </Form.Row>

                                {/* ✅ One row with 3 columns at the end */}
                                <Form.Row className="align-items-center mt-3">
                                    <Col lg={4} md={12} sm={12}>
                                        {currentStep === 5 ? (
                                            <Form.Text className="text-success text-center">
                                                {successMessage}
                                            </Form.Text>
                                        ) : (
                                            <Form.Text className="text-danger text-center">
                                                {submitError}
                                            </Form.Text>
                                        )}
                                    </Col>

                                    <Col lg={4} md={12} sm={12} className="text-center">
                                        {/* Empty or extra element (optional middle spacing) */}
                                    </Col>

                                    <Col lg={4} md={12} sm={12} className="text-right">
                                        <Button
                                            style={{
                                                background: "linear-gradient(90deg, #8b51fB 0%, #e614e1 100%)",
                                                border: "none",
                                            }}
                                            onClick={this.handleSubmit}
                                            disabled={loadingSpinner === 1}
                                        >
                                            {loadingSpinner === 1 ? (
                                                <div className="spinner-border text-light" />
                                            ) : (
                                                "Submit"
                                            )}
                                        </Button>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default graphql(EDIT_STUDENT_BULK, {
    name: "editBulkStudent"
})(UpdateStudentsModal);